import { usePrevious } from '@react-hookz/web';
import { useEffect, useMemo } from 'react';
import { useBlockEventsGateway } from '../../context/BlockEventsGateway';
import type { NoCodeEventHandler } from '../../event';

export function useCanTriggerEvents(getEventHandler: () => NoCodeEventHandler) {
  const { canTriggerEvents, whitelistedEvents } = useBlockEventsGateway();
  const previousCanTriggerEvents = usePrevious(canTriggerEvents);

  // this is done so as to set the events gateway in render cycle whenever canTriggerEvents or whitelistedEvents is changed
  useMemo(() => {
    if (getEventHandler().getCanTriggerEvents() !== canTriggerEvents) {
      getEventHandler().setEventsGateway({
        canTriggerEvents,
        whitelistedEvents,
      });
    }
  }, [canTriggerEvents, getEventHandler, whitelistedEvents]);

  useEffect(() => {
    if (previousCanTriggerEvents === false && canTriggerEvents === true) {
      getEventHandler().processWaitingEvents();
    }
  }, [previousCanTriggerEvents, canTriggerEvents, getEventHandler]);
}
